import { SubcomponentsContentWrapperComponentBackgroundColor } from 'lib/api/strapi';
import { createContext } from 'react';


type TBackgroundStyleConfig = {
  theme: SubcomponentsContentWrapperComponentBackgroundColor;
};
export const BackgroundStyleContext = createContext<TBackgroundStyleConfig>(
  {theme: 'white'}
);